import { useMemo } from 'react';
import { useCurrentModule } from '../components';
import { useDomainIntent } from './useDomainIntent';
import { useIsPersonalizedContentEnabled, usePersonalizedParams } from './usePersonalizedParams';
const QUERY_OPTIONS = {
  staleTime: Infinity,
  refetchOnWindowFocus: false,
  useErrorBoundary: false
};
export const usePersonalizedFeatures = () => {
  const module = useCurrentModule();
  const isEnabled = useIsPersonalizedContentEnabled();
  const {
    params,
    enabled,
    isLoading: isParamsLoading
  } = usePersonalizedParams();
  const {
    showDomain
  } = useDomainIntent();
  const featuresRequest = useMemo(() => ({
    ...params,
    showDomain
  }), [params, showDomain]);
  const {
    data,
    isSuccess,
    isError,
    isLoading
  } = module.SDK.personalizedFeaturesApiClient.hooks.useGetPersonalizedFeatures(featuresRequest, enabled, QUERY_OPTIONS);
  const byFamily = useMemo(() => {
    const map = new Map();
    const items = data == null ? void 0 : data.items;
    if (Array.isArray(items)) {
      items.forEach(item => map.set(item.productFamilyId, item.featureRows));
    }
    return map;
  }, [data]);
  return {
    getFeatureRows: productFamilyId => isEnabled && productFamilyId ? byFamily.get(productFamilyId) : undefined,
    isLoading: isParamsLoading || enabled && (!isSuccess && !isError || isLoading),
    isEnabled
  };
};
//# sourceMappingURL=usePersonalizedFeatures.js.map